// A copy of the default request organization messages as-of February 18, 2020, jslib-nightly 1.22.0-alpha.13
import { enUSRequestOrgMessages } from './lib/intl/en-US';
import { csRequestOrgMessages } from './lib/intl/cs';
import { daRequestOrgMessages } from './lib/intl/da';
import { enGBRequestOrgMessages } from './lib/intl/en-GB';
import { esESRequestOrgMessages } from './lib/intl/es-ES';
import { esRequestOrgMessages } from './lib/intl/es';
import { fiRequestOrgMessages } from './lib/intl/fi';
import { frRequestOrgMessages } from './lib/intl/fr';
import { frCARequestOrgMessages } from './lib/intl/fr-CA';
import { huRequestOrgMessages } from './lib/intl/hu';
import { itRequestOrgMessages } from './lib/intl/it';
import { jaRequestOrgMessages } from './lib/intl/ja';
import { koRequestOrgMessages } from './lib/intl/ko';
import { noRequestOrgMessages } from './lib/intl/no';
import { plRequestOrgMessages } from './lib/intl/pl';
import { ptRequestOrgMessages } from './lib/intl/pt';
import { ptBRRequestOrgMessages } from './lib/intl/pt-BR';
import { ruRequestOrgMessages } from './lib/intl/ru';
import { svRequestOrgMessages } from './lib/intl/sv';
import { trRequestOrgMessages } from './lib/intl/tr';
import { zhRequestOrgMessages } from './lib/intl/zh';
import { zhHKRequestOrgMessages } from './lib/intl/zh-HK';
import { deRequestOrgMessages } from './lib/intl/de';
import { nlRequestOrgMessages } from './lib/intl/nl';

export const programId = '5d658d4f92e4901fb2fe1501';
export const successNotifierUrl = 'https://eduprofileservice.efddotcom.autodesk.com/sheerid/school';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    messagesWithLocale: {
        'en-US': enUSRequestOrgMessages,
        cs: csRequestOrgMessages,
        de: deRequestOrgMessages,
        da: daRequestOrgMessages,
        'en-GB': enGBRequestOrgMessages,
        'es-ES': esESRequestOrgMessages,
        es: esRequestOrgMessages,
        fi: fiRequestOrgMessages,
        fr: frRequestOrgMessages,
        'fr-CA': frCARequestOrgMessages,
        hu: huRequestOrgMessages,
        it: itRequestOrgMessages,
        ja: jaRequestOrgMessages,
        ko: koRequestOrgMessages,
        no: noRequestOrgMessages,
        nl: nlRequestOrgMessages,
        pl: plRequestOrgMessages,
        pt: ptRequestOrgMessages,
        'pt-BR': ptBRRequestOrgMessages,
        ru: ruRequestOrgMessages,
        sv: svRequestOrgMessages,
        tr: trRequestOrgMessages,
        zh: zhRequestOrgMessages,
        'zh-HK': zhHKRequestOrgMessages,
    },
};
